import { Alert, Button, Flex } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { TOUCH } from "../../../components/Esign/signing/touch.ts"
import { RoutesPaths } from "../../../constants/routes.ts"
import { useAwaitingCountersignature } from "../hooks/use-awaiting-countersignature.ts"

interface AwaitingCountersignatureProps {
  leadId: string | undefined
}

export const AwaitingCountersignature = ({
  leadId
}: AwaitingCountersignatureProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const envelopes = useAwaitingCountersignature(leadId)

  if (envelopes.length === 0) return null

  return (
    <Flex vertical gap={"small"}>
      {envelopes.map((envelope) => {
        const document = envelope.subject?.name
        const to = RoutesPaths.esign.sign(envelope.id)
        const open = t("esign.countersign.open")
        return (
          <Alert
            key={envelope.id}
            type={"warning"}
            showIcon
            message={
              document
                ? t("esign.countersign.awaiting", { document })
                : t("esign.countersign.awaitingUnnamed")
            }
            action={
              <Button
                type={"primary"}
                href={to}
                aria-label={document ? `${open}: ${document}` : open}
                onClick={(event) => {
                  // Modified clicks belong to the browser (new tab, new window).
                  if (
                    event.defaultPrevented ||
                    event.button !== 0 ||
                    event.metaKey ||
                    event.ctrlKey ||
                    event.shiftKey ||
                    event.altKey
                  )
                    return
                  event.preventDefault()
                  navigate(to)
                }}
                style={TOUCH}
              >
                {open}
              </Button>
            }
          />
        )
      })}
    </Flex>
  )
}
